<template>
    <b-modal ref="mdlRegistraUscitaEntrata" :title="title" centered no-close-on-backdrop no-close-on-esc hide-header-close size="xl" @shown="onShow" scrollable>
        <!-- SCHEDA DEL PAZIENTE DA IMPLEMENTARE CON PRESENZA DA COMPLETARE -->
        <b-row>
            <b-col cols="12">
                <div class="alert alert-info">
                    <strong>{{ pazienteInfo.nome }} {{ pazienteInfo.cognome }}</strong
                    ><br />
                    <p>Codice Fiscale: {{ pazienteInfo.identificativo }}</p>
                    <div v-if="tipoOperazione === 'USCITA_PRESENZA'">
                        <p><strong>Entrata:</strong>{{ formatDateTime(uscitaDaCompletare.dataOraEntrata) }}</p>
                    </div>
                    <!--    <div v-if="uscitaDaCompletare && tipoOperazione === 'PRESENZA'" class="mt-3">
                        <p><strong>Uscita da completare:</strong> {{ formatDateTime(uscitaDaCompletare.dataOraUscita) }}</p>
                        <p><strong>Motivo: </strong> {{ uscitaDaCompletare.motivo || "Nessun motivo" }}</p>
                        <p><strong>Note Uscita Programmata: </strong> {{ uscitaDaCompletare.noteUscitaProgrammata || "Nessuna nota" }}</p>
                        <p><strong>Note Uscita: </strong> {{ uscitaDaCompletare.noteUscita || "Nessuna nota" }}</p>
                    </div> -->
                    <!--    <div v-if="uscitaSelezionata" class="mt-3">
                        <strong>Uscita programmata selezionata: {{ formatDateTime(uscitaSelezionata.dataOraUscitaProgrammata) }} </strong>
                        <p><strong>Motivo:</strong> {{ uscitaSelezionata.motivo || "Nessun motivo" }}</p>
                    </div> -->
                </div>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12" sm="12">
                <span class="sa-form-label">{{ tipoOperazione === "PRESENZA" ? "Data/Ora Entrata" : "Data/Ora Uscita" }}</span>
                <date-picker format="DD/MM/YYYY HH:mm" value-type="timestamp" v-model="currentDateTime" type="datetime"></date-picker>
            </b-col>
            <b-col cols="12">
                <span class="sa-form-label">Note</span>
                <b-form-textarea v-model="noteCorrente" rows="7" max-rows="10" placeholder="Note aggiuntive (opzionale)..."></b-form-textarea>
            </b-col>
        </b-row>
        <br />
        <div v-if="tipoOperazione === 'USCITA'">
            <b-row>
                <b-col cols="12">
                    <h5 class="mb-3">Seleziona l'uscita programmata da registrare</h5>
                </b-col>
            </b-row>
        </div>
        <template #modal-footer>
            <b-button size="md" variant="outline-danger" @click="onCloseModal">Annulla</b-button>
            <b-button v-if="tipoOperazione === 'USCITA' && !uscitaSelezionata && isUscitaUrgenza" size="md" variant="outline-warning" @click="onClickUscitaUrgenza">
                Uscita
                <font-awesome-icon icon="exclamation-triangle" class="mr-2" />
            </b-button>
            <b-button v-else size="md" variant="outline-success" @click="onClickSalva">
                {{ getSaveButtonText() }}
            </b-button>
        </template>
        <!-- <rsa-scheda-ospite-uscite-list-component ref="cmpRsaSchedaOspiteUsciteList" /> -->
        <modal-error ref="cmpModalError"></modal-error>
    </b-modal>
</template>

<script>
import UtilityMixin from "../../../utility/UtilityMixin";
import DatePicker from "vue2-datepicker";
import ModalError from "../../../../template/components/modal/components/ModalError.vue";
/* import RsaSchedaOspiteUsciteListComponent from "./RsaSchedaOspiteUsciteListComponent.vue"; */

export default {
    name: "RsaRegistrazioneEntrateUsciteModalEditComponent",
    mixins: [UtilityMixin],
    components: { DatePicker, ModalError /* RsaSchedaOspiteUsciteListComponent */ },

    data() {
        return {
            title: "",
            tipoOperazione: null, // 'PRESENZA' o 'USCITA'
            pathResource: "/rsapazientepresenze",
            pathResourceDizionario: "/rsadizionario",
            //Gestione USCITE
            usciteProgrammate: [],
            isUscitaUrgenza: false,
            uscitaSelezionata: null,
            //Gestione ENTRATE
            uscitaDaCompletare: {},
            pazienteInfo: {
                id: null,
                nome: "",
                cognome: "",
                identificativo: "",
            },
            jsonDataPresenza: {
                id: null,
                idAccettazione: null,
                dataOraUscitaProgrammata: null,
                dataOraUscita: null,
                dataOraEntrataProgrammata: null,
                dataOraEntrata: null,
                tipo: null,
                motivo: "",
                assenteNellaData: true,
                noteEntrata: null,
                noteUscita: null,
            },
            motivoOptions: [],
            jsonDataAccettazione: {},
        };
    },
    computed: {
        canSave() {
            // Per PRESENZA: deve avere trovato un'uscita da completare
            if (this.tipoOperazione === "PRESENZA") {
                return this.uscitaDaCompletare;
            }
            // Per USCITA: deve aver selezionato un'uscita programmata O essere uscita urgenza
            if (this.tipoOperazione === "USCITA") {
                if (this.isUscitaUrgenza) {
                    // Per uscita urgenza: dataOraUscita E motivo sono obbligatori
                    return this.jsonDataPresenza.dataOraUscita && this.jsonDataPresenza.motivo && this.jsonDataPresenza.motivo.trim() !== "";
                }
                return this.uscitaSelezionata && this.jsonDataPresenza.dataOraUscita;
            }
            return false;
        },
        currentDateTime: {
            get() {
                let me = this;
                if (me.tipoOperazione === "PRESENZA") {
                    return me.jsonDataPresenza.dataOraEntrata || new Date().getTime();
                } else {
                    //Stessa cosa
                    return me.jsonDataPresenza.dataOraUscita || new Date().getTime();
                }
            },
            set(value) {
                let me = this;
                if (me.tipoOperazione === "PRESENZA") {
                    me.jsonDataPresenza.dataOraEntrata = value;
                } else {
                    me.jsonDataPresenza.dataOraUscita = value;
                }
            },
        },
        noteCorrente: {
            get() {
                let me = this;
                let returnValue = "";
                if (me.tipoOperazione === "PRESENZA") {
                    returnValue = me.jsonDataPresenza.noteEntrata || "";
                } else {
                    returnValue = me.jsonDataPresenza.noteUscita || "";
                }
                return returnValue;
            },
            set(value) {
                let me = this;
                if (me.tipoOperazione === "PRESENZA") {
                    me.jsonDataPresenza.noteEntrata = value;
                } else {
                    me.jsonDataPresenza.noteUscita = value;
                }
            },
        },
    },

    mounted() {
        // let me = this;
        // me.loadDizionarioData();
    },
    watch: {
        isUscitaUrgenza: function (newIsUscitaUrgenza) {
            if (newIsUscitaUrgenza) {
                // console.log("Modalità uscita d'urgenza attivata", this.isUscitaUrgenza);
            }
        },
    },
    methods: {
        // ==================== METODI PRINCIPALI ====================
        show(paziente, tipoOperazione) {
            let me = this;
            me.jsonDataAccettazione = paziente;
            me.pazienteInfo = {
                id: paziente.id,
                nome: paziente.nome,
                cognome: paziente.cognome,
                identificativo: paziente.identificativo,
            };
            me.tipoOperazione = tipoOperazione;
            me.title = tipoOperazione === "PRESENZA" ? "Registra Presenza" : "Registra Uscita";
            me.uscitaSelezionata = null;
            me.isUscitaUrgenza = false;
            me.uscitaDaCompletare = null;
            me.jsonDataPresenza = {
                id: null,
                idAccettazione: paziente.id,
                dataOraUscitaProgrammata: null,
                dataOraUscita: tipoOperazione === "USCITA" ? new Date().getTime() : null,
                dataOraEntrataProgrammata: null,
                dataOraEntrata: tipoOperazione === "PRESENZA" ? new Date().getTime() : null,
                tipo: tipoOperazione === "USCITA_PRESENZA" ? "PRESENZA" : tipoOperazione,
                motivo: "",
                assenteNellaData: false,
                noteEntrata: null,
                noteUscita: null,
                statoAttuale: me.jsonDataAccettazione.statoAttuale,
            };
            me.loadDizionarioData();
            me.$refs.mdlRegistraUscitaEntrata.show();
        },
        onShow() {
            let me = this;
            if (me.tipoOperazione === "USCITA_PRESENZA") {
                me.loadDataPresenza();
            } /* else if (me.tipoOperazione === "PRESENZA") {
                me.loadDataEntrataUscita();
            } */
        },
        loadDizionarioData() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourceDizionario, null, me.loadDizionarioDataSuccess, me.loadDizionarioDataError);
        },
        loadDizionarioDataSuccess(response) {
            let me = this;
            if (response.data?.data?.list) {
                me.motivoOptions = response.data.data.list.filter((item) => item.tipo === "MOTIVAZIONE_PRESENZE_USCITE");
            }
        },
        loadDizionarioDataError(error) {
            console.error("Errore nel caricamento delle motivazioni", error);
        },
        // ==================== UTILITY ====================
        getSaveButtonText() {
            let returnValue = "";
            if (this.tipoOperazione === "PRESENZA") {
                returnValue = "Registra Presenza";
            } else {
                returnValue = "Registra Uscita";
            }
            return returnValue;
        },

        onCloseModal() {
            let me = this;
            me.$refs.mdlRegistraUscitaEntrata.hide();
            me.$emit("onClose");
        },
        // ==================== GESTIONE PRESENZE ====================

        /*   loadDataEntrataUscita() {
            let me = this;
            let filtroUscite = { idAccettazione: me.pazienteInfo.id, page: 1, forPage: 50 };
            me.loadDataResources(me.pathResource, filtroUscite, me.loadDataEntrataUscitaSuccess, me.loadDataEntrataUscitaError);
        },
        loadDataEntrataUscitaSuccess(response) {
            let me = this;
            let presenze = response.data?.data?.list;
            let usciteDaCompletare = presenze.filter((presenza) => !presenza.dataOraUscita && presenza.dataOraEntrata);
            if (usciteDaCompletare.length > 0) {
                me.uscitaDaCompletare = usciteDaCompletare[0];
                // Precompila il form con i dati dell'uscita da completare
                me.jsonDataPresenza.id = me.uscitaDaCompletare.id;
                me.jsonDataPresenza.dataOraUscitaProgrammata = me.uscitaDaCompletare.dataOraUscitaProgrammata;
                me.jsonDataPresenza.dataOraUscita = me.uscitaDaCompletare.dataOraUscita;
                me.jsonDataPresenza.dataOraEntrataProgrammata = me.uscitaDaCompletare.dataOraEntrataProgrammata;
                me.jsonDataPresenza.motivo = me.uscitaDaCompletare.motivo;
                me.jsonDataPresenza.noteUscitaProgrammata = me.uscitaDaCompletare.noteUscitaProgrammata;
                me.jsonDataPresenza.noteUscita = me.uscitaDaCompletare.noteUscita;
                // console.log("Uscita da completare trovata:", me.uscitaDaCompletare);
            } else {
                // console.log("Nessuna uscita da completare trovata");
                me.uscitaDaCompletare = null;
            }
        },
        loadDataEntrataUscitaError(response) {
            let me = this;
            me.$refs.cmpModalError.show(response.data.data);
        },
 */
        // ==================== GESTIONE SELEZIONE ====================
        onSelectUscitaProgrammata(uscitaProgrammata) {
            let me = this;
            me.isUscitaUrgenza = false;
            me.uscitaSelezionata = uscitaProgrammata;
            //Popolo campi del form
            me.jsonDataPresenza.id = uscitaProgrammata.id;
            me.jsonDataPresenza.dataOraUscitaProgrammata = uscitaProgrammata.dataOraUscitaProgrammata;
            me.jsonDataPresenza.dataOraEntrataProgrammata = uscitaProgrammata.dataOraEntrataProgrammata;
            me.jsonDataPresenza.motivo = uscitaProgrammata.motivo;
            me.jsonDataPresenza.noteUscitaProgrammata = uscitaProgrammata.noteUscitaProgrammata;
            me.jsonDataPresenza.assenteNellaData = uscitaProgrammata.assenteNellaData;
        },
        // ==================== GESTIONE SALVATAGGIO ====================
        onClickUscitaUrgenza() {
            let me = this;
            me.$bvModal
                .msgBoxConfirm("Stai per registrare un'uscita d'urgenza non programmata. Vuoi continuare?", {
                    title: "Conferma Uscita d'Urgenza",
                    size: "md",
                    okVariant: "outline-warning",
                    okTitle: "Sì, continua",
                    cancelTitle: "Annulla",
                    footerClass: "p-2",
                    hideHeaderClose: false,
                    centered: true,
                })
                .then((value) => {
                    if (value) {
                        me.isUscitaUrgenza = true;
                        me.uscitaSelezionata = null;
                        me.jsonDataPresenza.id = null;
                        me.jsonDataPresenza.idAccettazione = me.pazienteInfo.id;
                        me.jsonDataPresenza.dataOraUscitaProgrammata = null;
                        me.jsonDataPresenza.dataOraEntrataProgrammata = null;

                        if (!me.jsonDataPresenza.dataOraUscita) {
                            me.jsonDataPresenza.dataOraUscita = new Date().getTime();
                        }
                        me.jsonDataPresenza.tipo = "USCITA";
                        me.jsonDataPresenza.assenteNellaData = false;
                        me.onClickSalva();
                    }
                });
        },

        onClickSalva() {
            let me = this;
            /*      console.log(me.jsonDataPresenza);
            console.log(me.tipoOperazione);
            if (me.tipoOperazione === "PRESENZA" || me.tipoOperazione === "USCITA_PRESENZA") {
                me.pathResource = me.pathResource + "/semiresidenziale";
            }
            console.log(me.pathResource); */
            me.saveResource(me.pathResource + "/semiresidenziale", me.jsonDataPresenza, me.saveSuccessResponse, me.saveErrorResponse);
        },

        saveSuccessResponse(response) {
            let me = this;
            me.$emit("onSave", response, me.tipoOperazione);
            me.$refs.mdlRegistraUscitaEntrata.hide();
            me.$bvToast.toast(`${me.tipoOperazione} registrata con successo`, {
                title: "Successo",
                variant: "success",
                solid: true,
            });
        },
        saveErrorResponse(error) {
            let me = this;
            me.$refs.cmpModalError.show(error.response.data.messaggio);
        },
        loadDataPresenza() {
            let me = this;
            me.loadDataResources(me.pathResource + "/semiresidenziale/" + me.jsonDataAccettazione.id, {}, me.resultResponsePresenza, me.resultErrorPresenza);
        },
        resultResponsePresenza(response) {
            let me = this;
            console.log(response.data.data);
            if (response.data.data) {
                me.uscitaDaCompletare = response.data.data;
                me.jsonDataPresenza.id = me.uscitaDaCompletare.id;
                me.jsonDataPresenza.dataOraEntrata = me.uscitaDaCompletare.dataOraEntrata;
                me.jsonDataPresenza.motivo = me.uscitaDaCompletare.motivo;
                me.jsonDataPresenza.noteEntrata = me.uscitaDaCompletare.noteEntrata;
                me.jsonDataPresenza.dataOraUscita = new Date().getTime();
            }
        },
        resultErrorPresenza(error) {
            console.log(error);
        },
    },
};
</script>
<style scoped>
.bold-label {
    font-weight: bold;
}
</style>
